<div class="main">
  <router-outlet></router-outlet>
  <div [style.flex]="1"></div>
</div>